import * as z from "zod";

export const getActualStoreUrl = {
  name: "getActualStoreUrl" as const,
  input: z.object({ storeUrl: z.string() }),
  output: z.object({ actualUrl: z.string() }),
};
